import { getExternalStoreMessages, useAuiState } from '@assistant-ui/react';
import { answerProgressStatus } from '@/lib/answer-progress';
import { useNamespaceCopy } from '@/i18n/ns';
import copy from '@/i18n/ns/answer-progress';

export function AnswerProgressNotice() {
  const strings = useNamespaceCopy(copy);
  const status = useAuiState((state) => {
    if (state.message.role !== 'assistant' || state.message.status?.type === 'running') return null;
    const external = getExternalStoreMessages(state.message)[0] as
      | { metadata?: unknown }
      | undefined;
    return answerProgressStatus(external?.metadata ?? state.message.metadata);
  });
  if (!status) return null;
  return (
    <p
      role="status"
      data-slot="answer-progress-notice"
      className="text-muted-foreground mt-2 text-sm"
    >
      {strings[status]}
    </p>
  );
}
